import { createUseStyles } from "react-jss";
import { ITheme } from "../../types/theme";

// To check support for older iOS version
const hasHTMLDialog = typeof HTMLDialogElement === "function";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    insetInlineStart: 0,
    insetInlineEnd: 0,
    height: "fit-content",
    margin: "auto",
    overflow: "visible",
    outline: "none",
    background: `${theme.colors.background4} !important`,
    borderRadius: 16,
    display: "none",
    flexDirection: "column",
    border: "none",
    maxWidth: 343,
    width: `calc(100% - ${theme.spacing.space16}px)`,
    padding: `24px 16px`,
    boxSizing: "border-box",
    gap: theme.spacing.space24,
    "&::backdrop": {
      backgroundColor: `rgba(0,0,0, 0.7)`,
    },
    ...(hasHTMLDialog
      ? {
          "&[open]": {
            display: "flex",
          },
        }
      : {
          "&.open": {
            display: "flex",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          },
        }),
  },
  icon: {
    height: 100,
    margin: "auto",
    overflow: "hidden",
    textAlign: "center",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    gap: theme.spacing.space8,
  },
  btns: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing.space12,
  },
}));
